import { Injectable } from '@angular/core';
import { PayrollService } from '../../hrms/service/payroll.service';
import { MainService } from '../../hrms/service/main.service';
import * as  pdfMake from "pdfmake/build/pdfmake";
import * as  pdfFonts from "pdfmake/build/vfs_fonts";
import { NgxSpinnerService } from 'ngx-spinner';

import { Workbook } from 'exceljs';
// import * as fs from 'file-saver';
import * as  fs from "file-saver";
import Swal from 'sweetalert2';


declare var $: any
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
@Injectable({
  providedIn: 'root'
})
export class PrintSalBillService {

  constructor(private mainService: MainService, private payrollService: PayrollService, private spinner: NgxSpinnerService) { }
  b_acct_id :any;
  monthObj :any  = { '1': 'January', '2': 'February', '3': 'March', '4': 'April', '5': 'May', '6': 'June', '7': 'July', '8': 'August', '9': 'September', '10': 'October', '11': 'November', '12': 'December' }
  monthObjShort = { '1': 'JAN', '2': 'FEB', '3': 'MAR', '4': 'APR', '5': 'MAY', '6': 'JUN', '7': 'JUL', '8': 'AUG', '9': 'SEP', '10': 'OCT', '11': 'NOV', '12': 'DEC' }
  monthEnd = { '1': 31, '2': 28, '3': 31, '4': 30, '5': 31, '6': 30, '7': 31, '8': 31, '9': 30, '10': 31, '11': 30, '12': 31 }



  async printSalbill(req :any, erpUser :any, type :any) {
    this.b_acct_id = erpUser.b_acct_id;
    await this.getAllBill(req, type, erpUser);
  }
  async printSalbill1(req :any, erpUser :any, type :any) {
    this.b_acct_id = erpUser.b_acct_id;
    await this.getAllBill1(req, type, erpUser);
  }
  async printSalbill2(req :any, erpUser :any, type :any) {
    this.b_acct_id = erpUser.b_acct_id;
    await this.getAllBill2(req, type, erpUser);
  }

  async getAllBill2(element :any, type :any, erpUser :any) {
    console.log(element)
    this.currentBillObj = { header: {}, allEmployees: [], data: {}, sums: {} };
    var element1 = JSON.parse(element);
    var obj :any= new Object();
    element1['b_acct_id'] = this.b_acct_id
    // obj['b_acct_id'] = this.b_acct_id;
    // obj['bill_id'] = element1['bill_id'];
    this.spinner.show()
    obj = element1;
    var obj1:any = new Object();
    obj1['b_acct_id'] = this.b_acct_id
    var resp1 = await this.payrollService.getAllComponent(JSON.stringify(obj1));
    if (resp1['error'] == false) {
      this.all_component = resp1.data;
    } else {
      return;
    }

    let obb:any = new Object();
    obb['emp_id'] = '';
    obb['emp_name'] = '';
    obb['designation_code'] = '';
    obb['grade_pay_code'] = '';
    obb['pay_band'] = '';
    obb['sal_acc'] = '';
    obb['pf'] = '';
    obb['pf_ifsc'] = '';

    for (let i = 0; i < this.all_component.length; i++) {
      if (this.all_component[i]['pay_code'] == 'PAY') {
        obb[this.all_component[i]['component_code']] = 0
      }
    }

    obb['gross_pay'] = 0
    for (let i = 0; i < this.all_component.length; i++) {
      if (this.all_component[i]['pay_code'] == 'DED') {
        obb[this.all_component[i]['component_code']] = 0
      }
    }
    obb['total'] = 0
    obb['net'] = 0;
    let obj11:any = {}
    this.arr = obj['data'].map((item:any) => item.bill_id)
    console.log(this.arr, "lll")
    obj11["arr"] = this.arr
    obj11["b_acct_id"] = this.b_acct_id
    obj11['month'] = obj['month']
    obj11['year'] = obj['fin_year']
    obj11['bill_status_code'] = obj['bill_status_code']
    obj11['type'] = obj['type']
    console.log(obj11)

    // var resp = await this.payrollService.getselectedBill(JSON.stringify(obj11));
    var resp = await this.payrollService.getselectedBill(obj11);

    let resp11 = await this.payrollService.getAlluser(obj11);
    if (resp11["error"] == false) {
      this.AllUser = resp11.data
    }
    console.log(this.AllUser, "kkll")
    if (resp['error'] == false) {
      this.spinner.hide()
      var billObj :any= {};
      var header :any= "";
      var dt :any= resp['data'];
      // Create a map to store the designation codes by arr_id
      const designationMap:any = {};

      // Populate the map with designation codes from the second array
      this.AllUser.forEach((item:any) => {
        designationMap[item.arr_id] = item.designation_code;
      });

      // console.log(designationMap,"llkj")
      // Update the first array with designation codes
      dt.forEach((item:any) => {
        const arr_id = item.arr_id; // Assuming arr_id is stored in the 'id' field of the first array
        if (designationMap[arr_id]) {
          item.designation_code = designationMap[arr_id];
        }
      });
      const sectionMap:any = {}
      obj['data'].forEach((item:any) => {
        sectionMap[item.bill_id] = item.leaf_value;
      });
      dt.forEach((item:any) => {
        const bill_id = item.bill_id; // Assuming arr_id is stored in the 'id' field of the first array
        if (sectionMap[bill_id]) {
          item.leaf_value = sectionMap[bill_id];
        }
      });
      // Now, firstArray contains the designation_code from the second array
      console.log(dt);
      // console.log(dt)
      if (dt.length > 0) {
        header = dt[0];
      }
      var grand = undefined;
      var month = "";
      var fin_year = "";
      var fixedarr = [];

      for (var i = 0; i < dt.length; i++) {

        if (billObj[dt[i]['section_code']] == undefined) {
          month = dt[i]['month'];
          fin_year = dt[i]['fin_year'];
          billObj[dt[i]['section_code']] = {};
          billObj[dt[i]['section_code']]['data'] = {};//{'BASIC':0.00,'DA':0.00,'DEP':0.00,'HRA':0.00,'MA':0.00,'VA':0.00,'WA':0.00,'miscpay':[],'LIC1':0.00,LIC2:0.00,LIC3:0.00,LIC4:0.00,LIC5:0.00,LIC6:0.00,LIC7:0.00,PF:0.00,GIS:0.00,IT:0.00,HRR:0.00,VD:0.00,VADV:0.00,BLDADV1:0.00,BLDADV2:0.00,BLDADV3:0.00,PFADV:0.00,PFADV1:0.00,PFADV2:0.00,BADV:0.00,EWF:0.00,miscded:[]};
          billObj[dt[i]['section_code']]['total'] = { 'BASIC': 0.00, 'DA': 0.00, 'DEP': 0.00, 'HRA': 0.00, 'MA': 0.00, 'VA': 0.00, 'WA': 0.00, 'miscpay': [], 'LIC1': 0.00, LIC2: 0.00, LIC3: 0.00, LIC4: 0.00, LIC5: 0.00, LIC6: 0.00, LIC7: 0.00, PF: 0.00, NPS: 0.00, GIS: 0.00, IT: 0.00, HRR: 0.00, VD: 0.00, VADV: 0.00, BLDADV1: 0.00, BLDADV2: 0.00, BLDADV3: 0.00, PFADV: 0.00, PFADV1: 0.00, PFADV2: 0.00, BADV: 0.00, EWF: 0.00, miscded: [], total: 0.00, net: 0.00 };
          if (grand == undefined) {
            grand = { 'BASIC': 0.00, 'DA': 0.00, 'DEP': 0.00, 'HRA': 0.00, 'MA': 0.00, 'VA': 0.00, 'WA': 0.00, 'miscpay': [], 'LIC1': 0.00, LIC2: 0.00, LIC3: 0.00, LIC4: 0.00, LIC5: 0.00, LIC6: 0.00, LIC7: 0.00, PF: 0.00, NPS: 0.00, GIS: 0.00, IT: 0.00, HRR: 0.00, VD: 0.00, VADV: 0.00, BLDADV1: 0.00, BLDADV2: 0.00, BLDADV3: 0.00, PFADV: 0.00, PFADV1: 0.00, PFADV2: 0.00, BADV: 0.00, EWF: 0.00, miscded: [], total: 0.00, net: 0.00 };
          }
        }
        if (billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]] == undefined) {
          fixedarr = []
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]] = Object.assign({}, obb);
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['emp_id'] = (dt[i]['emp_id']);
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['emp_name'] = dt[i]['emp_name']
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['month'] = dt[i]['month']
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['designation_code'] = dt[i]['designation_code']
          if (dt[i]['leaf_value'] != undefined) {
            billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['leaf_value'] = dt[i]['leaf_value']

          }

          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['grade_pay_code'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['pay_band'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['sal_acc'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['pf'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['pf_ifsc'] = ''
        }


        // if (dt[i]['pay_code'] == 'PAY') {
        //   billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']+'-'+[dt[i]['month']]['gross_pay']] += dt[i]['pay_component_amt'];
        //   billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']+'-'+[dt[i]['month']]['net']]+= dt[i]['pay_component_amt'];
        //   // ['net'] += dt[i]['pay_component_amt'];
        //   billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']+'-'+[dt[i]['month']]][dt[i]['pay_component_code']] += dt[i]['pay_component_amt']

        // } else {
        //   billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']+'-'+[dt[i]['month']]]['total'] += dt[i]['pay_component_amt'];
        //   billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']+'-'+[dt[i]['month']]]['net'] -= dt[i]['pay_component_amt'];
        //   billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']+'-'+[dt[i]['month']]][dt[i]['pay_component_code']] += dt[i]['pay_component_amt']

        // }

        if (dt[i]['pay_code'] == 'PAY') {
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['gross_pay'] += dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['net'] += dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]][dt[i]['pay_component_code']] += dt[i]['pay_component_amt']

        } else {
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['total'] += dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['net'] -= dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]][dt[i]['pay_component_code']] += dt[i]['pay_component_amt']

        }


      }
      //  console.log(billObj,"koo")
      if (type === 'PDF') {
        this.print(billObj, header, month, fin_year);
      } if (type === 'EXCEL') {
        this.exportExcel2(billObj, header, erpUser);

      }


      // this.spinner.hide()
    } else {
      // this.spinner.hide();
      // swal.fire("Error", "Error while printing pay bill", 'error')
    }
  }
  arr :any= []
  async getAllBill1(element:any, type:any, erpUser:any) {
    console.log(element)
    this.currentBillObj = { header: {}, allEmployees: [], data: {}, sums: {} };
    var element1 = JSON.parse(element);
    var obj:any = new Object();
    element1['b_acct_id'] = this.b_acct_id
    // obj['b_acct_id'] = this.b_acct_id;
    // obj['bill_id'] = element1['bill_id'];
    this.spinner.show()
    obj = element1;
    var obj1:any = new Object();
    obj1['b_acct_id'] = this.b_acct_id
    var resp1 = await this.payrollService.getAllComponent(JSON.stringify(obj1));
    if (resp1['error'] == false) {
      this.all_component = resp1.data;
    } else {
      return;
    }

    let obb :any= new Object();
    obb['emp_id'] = '';
    obb['emp_name'] = '';
    obb['designation_code'] = '';
    obb['grade_pay_code'] = '';
    obb['pay_band'] = '';
    obb['sal_acc'] = '';
    obb['pf'] = '';
    obb['pf_ifsc'] = '';

    for (let i = 0; i < this.all_component.length; i++) {
      if (this.all_component[i]['pay_code'] == 'PAY') {
        obb[this.all_component[i]['component_code']] = 0
      }
    }

    obb['gross_pay'] = 0
    for (let i = 0; i < this.all_component.length; i++) {
      if (this.all_component[i]['pay_code'] == 'DED') {
        obb[this.all_component[i]['component_code']] = 0
      }
    }
    obb['total'] = 0
    obb['net'] = 0;
    let obj11:any = {}
    this.arr = obj['data'].map((item:any) => item.bill_id)
    console.log(this.arr, "lll")
    obj11["arr"] = this.arr
    obj11["b_acct_id"] = this.b_acct_id
    obj11['month'] = obj['month']
    obj11['year'] = obj['fin_year']
    obj11['bill_status_code'] = obj['bill_status_code']
    obj11['type'] = obj['type']
    console.log(obj11)

    // var resp = await this.payrollService.getselectedBill(JSON.stringify(obj11));
    var resp = await this.payrollService.getselectedBill(obj11);

    let resp11 = await this.payrollService.getAlluser(obj11);
    if (resp11["error"] == false) {
      this.AllUser = resp11.data
    }
    console.log(this.AllUser, "kkll")
    if (resp['error'] == false) {
      this.spinner.hide()
      var billObj:any = {};
      var header:any = "";
      var dt :any= resp['data'];
      // Create a map to store the designation codes by arr_id
      const designationMap :any= {};

      // Populate the map with designation codes from the second array
      this.AllUser.forEach((item:any) => {
        designationMap[item.arr_id] = item.designation_code;
      });

      // console.log(designationMap,"llkj")
      // Update the first array with designation codes
      dt.forEach((item:any) => {
        const arr_id = item.arr_id; // Assuming arr_id is stored in the 'id' field of the first array
        if (designationMap[arr_id]) {
          item.designation_code = designationMap[arr_id];
        }
      });
      const sectionMap:any = {}
      obj['data'].forEach((item:any) => {
        sectionMap[item.bill_id] = item.leaf_value;
      });
      dt.forEach((item:any) => {
        const bill_id = item.bill_id; // Assuming arr_id is stored in the 'id' field of the first array
        if (sectionMap[bill_id]) {
          item.leaf_value = sectionMap[bill_id];
        }
      });
      // Now, firstArray contains the designation_code from the second array
      console.log(dt);
      // console.log(dt)
      if (dt.length > 0) {
        header = dt[0];
      }
      var grand :any= undefined;
      var month:any = "";
      var fin_year:any = "";
      var fixedarr:any = [];

      for (var i = 0; i < dt.length; i++) {

        if (billObj[dt[i]['section_code']] == undefined) {
          month = dt[i]['month'];
          fin_year = dt[i]['fin_year'];
          billObj[dt[i]['section_code']] = {};
          billObj[dt[i]['section_code']]['data'] = {};//{'BASIC':0.00,'DA':0.00,'DEP':0.00,'HRA':0.00,'MA':0.00,'VA':0.00,'WA':0.00,'miscpay':[],'LIC1':0.00,LIC2:0.00,LIC3:0.00,LIC4:0.00,LIC5:0.00,LIC6:0.00,LIC7:0.00,PF:0.00,GIS:0.00,IT:0.00,HRR:0.00,VD:0.00,VADV:0.00,BLDADV1:0.00,BLDADV2:0.00,BLDADV3:0.00,PFADV:0.00,PFADV1:0.00,PFADV2:0.00,BADV:0.00,EWF:0.00,miscded:[]};
          billObj[dt[i]['section_code']]['total'] = { 'BASIC': 0.00, 'DA': 0.00, 'DEP': 0.00, 'HRA': 0.00, 'MA': 0.00, 'VA': 0.00, 'WA': 0.00, 'miscpay': [], 'LIC1': 0.00, LIC2: 0.00, LIC3: 0.00, LIC4: 0.00, LIC5: 0.00, LIC6: 0.00, LIC7: 0.00, PF: 0.00, NPS: 0.00, GIS: 0.00, IT: 0.00, HRR: 0.00, VD: 0.00, VADV: 0.00, BLDADV1: 0.00, BLDADV2: 0.00, BLDADV3: 0.00, PFADV: 0.00, PFADV1: 0.00, PFADV2: 0.00, BADV: 0.00, EWF: 0.00, miscded: [], total: 0.00, net: 0.00 };
          if (grand == undefined) {
            grand = { 'BASIC': 0.00, 'DA': 0.00, 'DEP': 0.00, 'HRA': 0.00, 'MA': 0.00, 'VA': 0.00, 'WA': 0.00, 'miscpay': [], 'LIC1': 0.00, LIC2: 0.00, LIC3: 0.00, LIC4: 0.00, LIC5: 0.00, LIC6: 0.00, LIC7: 0.00, PF: 0.00, NPS: 0.00, GIS: 0.00, IT: 0.00, HRR: 0.00, VD: 0.00, VADV: 0.00, BLDADV1: 0.00, BLDADV2: 0.00, BLDADV3: 0.00, PFADV: 0.00, PFADV1: 0.00, PFADV2: 0.00, BADV: 0.00, EWF: 0.00, miscded: [], total: 0.00, net: 0.00 };
          }

        }
        if (billObj[dt[i]['section_code']]['district'] == undefined) {
          billObj[dt[i]['section_code']]['district'] = {}
          billObj[dt[i]['section_code']]['district'] = element1['district']
        }
        if (billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']] == undefined) {
          fixedarr = []
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']] = Object.assign({}, obb);
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['emp_id'] = (dt[i]['emp_id']);
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['emp_name'] = dt[i]['emp_name']
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['designation_code'] = dt[i]['designation_code']
          if (dt[i]['leaf_value'] != undefined) {
            billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['leaf_value'] = dt[i]['leaf_value']

          }

          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['grade_pay_code'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['pay_band'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['sal_acc'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['pf'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['pf_ifsc'] = ''
        }

        if (dt[i]['pay_code'] == 'PAY') {
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['gross_pay'] += dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['net'] += dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']][dt[i]['pay_component_code']] += dt[i]['pay_component_amt']

        } else {
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['total'] += dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['net'] -= dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']][dt[i]['pay_component_code']] += dt[i]['pay_component_amt']

        }


      }
      //  console.log(billObj,"koo")
      if (type === 'PDF') {
        this.print(billObj, header, month, fin_year);
      } if (type === 'EXCEL') {
        this.exportExcel1(billObj, header, erpUser);

      }


      // this.spinner.hide()
    } else {
      // this.spinner.hide();
      // swal.fire("Error", "Error while printing pay bill", 'error')
    }
  }

  currentBillObj:any
  all_component:any = []
  AllUser :any= []
  async getAllBill(element:any, type:any, erpUser:any) {
    this.currentBillObj = { header: {}, allEmployees: [], data: {}, sums: {} };
    if (typeof element === 'object') {
      var element1 = element
    } else {
      var element1 = JSON.parse(element);
    }

    var obj = new Object();
    element1['b_acct_id'] = this.b_acct_id
    // obj['b_acct_id'] = this.b_acct_id;
    // obj['bill_id'] = element1['bill_id'];
    obj = element1;
    var resp1 = await this.payrollService.getAllComponent(JSON.stringify(obj));
    if (resp1['error'] == false) {
      this.all_component = resp1.data;
    } else {
      return;
    }

    let obb:any = new Object();
    obb['emp_id'] = '';
    obb['emp_name'] = '';
    obb['designation_code'] = '';
    obb['grade_pay_code'] = '';
    obb['pay_band'] = '';
    obb['sal_acc'] = '';
    obb['pf'] = '';
    obb['pf_ifsc'] = '';

    for (let i = 0; i < this.all_component.length; i++) {
      if (this.all_component[i]['pay_code'] == 'PAY') {
        obb[this.all_component[i]['component_code']] = 0
      }
    }

    obb['gross_pay'] = 0
    for (let i = 0; i < this.all_component.length; i++) {
      if (this.all_component[i]['pay_code'] == 'DED') {
        obb[this.all_component[i]['component_code']] = 0
      }
    }
    obb['total'] = 0
    obb['net'] = 0;
    console.log(obj)

    var resp = await this.payrollService.getAllBill(JSON.stringify(obj));
    let resp11 = await this.payrollService.getAlluser(JSON.stringify(obj));
    if (resp11["error"] == false) {
      this.AllUser = resp11.data
    }
    if (resp['error'] == false) {

      var billObj :any= {};
      var header:any = "";
      var dt :any= resp['data'];
      const empIdToDesignation = {
        [this.AllUser['arr_id']]: this.AllUser['designation_code'],
        // Add more mappings if needed
      };
      console.log(empIdToDesignation)
      // Use the map function to add the new column based on emp_id
      const newArray = dt.map((obj:any) => ({
        ...obj,
        designation_code: empIdToDesignation[obj.arr_id] || "", // Add the desired property here
      }));

      console.log(newArray);
      console.log(dt)
      if (dt.length > 0) {
        header = dt[0];
      }
      var grand :any= undefined;
      var month :any= "";
      var fin_year:any = "";
      var fixedarr:any = [];

      for (var i = 0; i < dt.length; i++) {
        if (billObj[dt[i]['section_code']] == undefined) {
          month = dt[i]['month'];
          fin_year = dt[i]['fin_year'];
          // if(billObj['leaf_value']=''){
          //   billObj['leaf_value']=''
          // }
          // billObj['leaf_value']=obj["leaf_value"]
          billObj[dt[i]['section_code']] = {};
          billObj[dt[i]['section_code']]['data'] = {};//{'BASIC':0.00,'DA':0.00,'DEP':0.00,'HRA':0.00,'MA':0.00,'VA':0.00,'WA':0.00,'miscpay':[],'LIC1':0.00,LIC2:0.00,LIC3:0.00,LIC4:0.00,LIC5:0.00,LIC6:0.00,LIC7:0.00,PF:0.00,GIS:0.00,IT:0.00,HRR:0.00,VD:0.00,VADV:0.00,BLDADV1:0.00,BLDADV2:0.00,BLDADV3:0.00,PFADV:0.00,PFADV1:0.00,PFADV2:0.00,BADV:0.00,EWF:0.00,miscded:[]};
          billObj[dt[i]['section_code']]['total'] = { 'BASIC': 0.00, 'DA': 0.00, 'DEP': 0.00, 'HRA': 0.00, 'MA': 0.00, 'VA': 0.00, 'WA': 0.00, 'miscpay': [], 'LIC1': 0.00, LIC2: 0.00, LIC3: 0.00, LIC4: 0.00, LIC5: 0.00, LIC6: 0.00, LIC7: 0.00, PF: 0.00, NPS: 0.00, GIS: 0.00, IT: 0.00, HRR: 0.00, VD: 0.00, VADV: 0.00, BLDADV1: 0.00, BLDADV2: 0.00, BLDADV3: 0.00, PFADV: 0.00, PFADV1: 0.00, PFADV2: 0.00, BADV: 0.00, EWF: 0.00, miscded: [], total: 0.00, net: 0.00 };
          if (grand == undefined) {
            grand = { 'BASIC': 0.00, 'DA': 0.00, 'DEP': 0.00, 'HRA': 0.00, 'MA': 0.00, 'VA': 0.00, 'WA': 0.00, 'miscpay': [], 'LIC1': 0.00, LIC2: 0.00, LIC3: 0.00, LIC4: 0.00, LIC5: 0.00, LIC6: 0.00, LIC7: 0.00, PF: 0.00, NPS: 0.00, GIS: 0.00, IT: 0.00, HRR: 0.00, VD: 0.00, VADV: 0.00, BLDADV1: 0.00, BLDADV2: 0.00, BLDADV3: 0.00, PFADV: 0.00, PFADV1: 0.00, PFADV2: 0.00, BADV: 0.00, EWF: 0.00, miscded: [], total: 0.00, net: 0.00 };
          }
        }
        if (billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']] == undefined) {
          fixedarr = []
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']] = Object.assign({}, obb);
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['emp_id'] = (dt[i]['emp_id']);
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['emp_name'] = dt[i]['emp_name']
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['designation_code'] = dt[i]['designation_code']
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['grade_pay_code'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['pay_band'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['sal_acc'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['pf'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['pf_ifsc'] = ''
        }

        if (dt[i]['pay_code'] == 'PAY') {
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['gross_pay'] += dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['net'] += dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']][dt[i]['pay_component_code']] += dt[i]['pay_component_amt']

        } else {
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['total'] += dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['net'] -= dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']][dt[i]['pay_component_code']] += dt[i]['pay_component_amt']

        }


      }

      if (type === 'PDF') {
        // this.print(billObj, header, month, fin_year,obj);
        this.print111(billObj, header, month, fin_year, obj);
      } if (type === 'EXCEL') {
        this.exportExcel(billObj, header, erpUser);

      }


      // this.spinner.hide()
    } else {
      // this.spinner.hide();
      // swal.fire("Error", "Error while printing pay bill", 'error')
    }
  }




  arr2:any=[]

  print111(billObj:any, header:any, month:any, fin_year:any, showobj:any) {

    var file_name = showobj['bill_desc'];
    // console.log(billObj, header, grand, showobj)
    //var txt = "VARANASASI DEVELOPMENT AUTHORITY(VDA)   Officers/THIRD/FOURTH Category EMPLOYEES STATEMENT FOR THE MONTH OF June,2020   PIRNT DATE: 2020-10-10"
    var txt = this.mainService.accInfo['account_name'] + "(" + this.mainService.accInfo['account_short_name'] + ")" + "   " + showobj['bill_desc'] + "   Date: " + header['accrual_date'];
    var dd :any= {
      pageSize: 'A3',
      header: function (currentPage:any, pageCount:any) {
        var obj = { text: txt + "     Page No. - " + currentPage, alignment: 'center', margin: [10, 10], bold: true };
        return obj;
      },

      //footer: function(currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount; },

      // by default we use portrait, you can change it to landscape if you wish
      pageOrientation: 'landscape',
      pageMargins: [50, 60, 40, 60],

      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      // pageMargins: [40, 60, 40, 60],
      // pageMargins: [ 40, 20, 20, 20 ],
      content: [
        // {
        //   // alignment: 'center', // Center the entire content
        //   // ... your existing content

        // },
      ]
    };

    var header01 = {
      columns: [
        {
          width: '*',
          text: this.mainService.accInfo['address'],
          bold: true,
          alignment: 'center'
        }
      ],

    }
    // dd.content.push({ text: " " });
    dd.content.push(header01)
    dd.content.push({ text: " " });
    this.arr2 = []
    var sections = Object.keys(billObj);
    var count = 0;
    for (var i = 0; i < sections.length; i++) {
      var data = billObj[sections[i]];

      var sectionText :any= { text: 'Section : ' + sections[i], fontSize: 8 };
      if (i != 0) {
        sectionText['pageBreak'] = 'before'
      }
      //dd.content.push(sectionText);
      let list = ['Emp\nDetail'];
      let data_keys: any = [];
      let width = ['auto'];
      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'PAY') {
          list.push(this.all_component[i]['component_code'])
          data_keys.push(this.all_component[i]['component_code'])
          width.push('auto')
        }
      }
      list.push('Total');
      data_keys.push('gross_pay');

      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'DED') {
          list.push(this.all_component[i]['component_code']);
          data_keys.push(this.all_component[i]['component_code'])

          width.push('auto')
        }
      }
      list.push('total');
      data_keys.push('total');
      width.push('auto');
      list.push('Net.\nSal.');
      width.push('auto');
      data_keys.push('net');

      console.log(width)

      var tbl :any= {

        // layout: 'lightHorizontalLines',
        fontSize: 10,


        table: {
          // id: 'myTable',
          alignment: 'center', // Center the entire content
          headerRows: 1,
          // widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
          widths: [],
          margin: [10, 10],
          body: [
            // ['Emp\nDetail', 'Basic\nPay', 'Dep.\nAllow', 'DA/Relief', 'Med\nAllow', 'Veh\nAllow', 'HRA', 'WA', 'Misc\nAllow', 'Total', 'LIC', 'PF\nDed', 'NPS', 'Group\nIns.', 'IT', 'House\nRent', 'Veh\nDed', 'Veh\nAdv.', 'Bld\nAdv.', 'PF\nAdv.', 'Bank\nAdv.', 'EWF', 'Misc\nDed', 'Net.\nSal.']
            // list
            []
          ],
          // pageMargins: [40, 60, 40, 60],
        }
      };
      // for (let i = 0; i < list.length; i++) {
      //   tbl.table.body[0].push(list[i]);
      //   tbl.table.widths.push('auto')
      // }
      // dd.content.push(tbl);
      var emps = Object.keys(data['data']);
      count = count + emps.length;

      console.log(data['data'])
      console.log(emps);
      //var total_arr = [];
      var total_obj :any= new Object();
      total_obj['emp_info'] = 'Total'
      // total_arr.push('Total')
      for (var j = 0; j < emps.length; j++) {
        var obj = data['data'][emps[j]];
        // var arr = [];
        // var str = obj['emp_id'] + "\n" + obj['emp_name']
        // // var str = obj['emp_id'] + "\n" + obj['emp_name'] + "\n" + obj['designation_code'] + "\n" + obj['grade_pay_code'] + "\n" + obj['pay_band'] + "\n" + "SAL A/C - " + obj['sal_acc'];
        // // if (obj['pf'] != undefined && obj['pf'] != null && obj['pf'] != 0) {
        // //   str += "\n" + "PF A/C - " + obj['pf']
        // // }
        // // if (obj['pf_ifsc'] != undefined && obj['pf_ifsc'] != null && obj['pf_ifsc'] != 0) {
        // //   str += "\n" + "PF Ifsc - " + obj['pf_ifsc']
        // // }
        // arr.push(str);
        for (let x = 0; x < data_keys.length; x++) {
          if (total_obj[data_keys[x]] == undefined) {
            total_obj[data_keys[x]] = parseInt((obj[data_keys[x]]).toFixed(0))
          } else {
            total_obj[data_keys[x]] = total_obj[data_keys[x]] + parseInt((obj[data_keys[x]]).toFixed(0))
          }
          // arr.push((obj[data_keys[x]]).toFixed(0))
          // total_arr.push(parseInt((obj[data_keys[x]]).toFixed(0)))
        }
        // if (obj['BASIC_arr'] != undefined) {
        //   for (let i = 0; i < obj['BASIC_arr'].length; i++) {
        //     if (i == 0) {
        //       var basic = obj['BASIC_arr'][i]

        //     } else {
        //       basic = basic + "\n" + obj['BASIC_arr'][i]

        //     }


        //   }
        //   arr.push(basic);
        // } else {
        //   arr.push(obj['BASIC']);

        // }
        // if (obj['DEP_arr'] != undefined) {
        //   for (let i = 0; i < obj['DEP_arr'].length; i++) {
        //     if (i == 0) {
        //       var DEP = obj['DEP_arr'][i]

        //     } else {
        //       DEP = DEP + "\n" + obj['DEP_arr'][i]

        //     }


        //   }
        //   arr.push(DEP);
        // } else {
        //   arr.push(obj['DEP']);

        // }
        //   if (obj['DA_arr'] != undefined) {
        //     for (let i = 0; i < obj['DA_arr'].length; i++) {
        //       if (i == 0) {
        //         var DA = obj['DA_arr'][i]

        //       } else {
        //         DA = DA + "\n" + obj['DA_arr'][i]

        //       }


        //     }
        //     arr.push(DA);
        //   } else {
        //     arr.push(obj['DA']);

        //   }
        //   if (obj['MA_arr'] != undefined) {
        //     for (let i = 0; i < obj['MA_arr'].length; i++) {
        //       if (i == 0) {
        //         var MA = obj['MA_arr'][i]

        //       } else {
        //         MA = MA + "\n" + obj['MA_arr'][i]

        //       }


        //     }
        //     arr.push(MA);
        //   } else {
        //     arr.push(obj['MA']);

        //   }
        //   if (obj['VA_arr'] != undefined) {
        //     for (let i = 0; i < obj['VA_arr'].length; i++) {
        //       if (i == 0) {
        //         var VA = obj['VA_arr'][i]

        //       } else {
        //         VA = VA + "\n" + obj['VA_arr'][i]

        //       }


        //     }
        //     arr.push(VA);
        //   } else {
        //     arr.push(obj['VA']);

        //   } if (obj['HRA_arr'] != undefined) {
        //     for (let i = 0; i < obj['HRA_arr'].length; i++) {
        //       if (i == 0) {
        //         var HRA = obj['HRA_arr'][i]

        //       } else {
        //         HRA = HRA + "\n" + obj['HRA_arr'][i]

        //       }


        //     }
        //     arr.push(HRA);
        //   } else {
        //     arr.push(obj['HRA']);

        //   }
        //   if (obj['WA_arr'] != undefined) {
        //     for (let i = 0; i < obj['WA_arr'].length; i++) {
        //       if (i == 0) {
        //         var WA = obj['WA_arr'][i]

        //       } else {
        //         WA = WA + "\n" + obj['WA_arr'][i]

        //       }


        //     }
        //     arr.push(WA);
        //   } else {
        //     arr.push(obj['WA']);

        //   }
        //   /*  arr.push(obj['DEP']);
        //    arr.push(obj['DA']);
        //    arr.push(obj['MA']); */
        //   //arr.push(obj['VA']);
        //   // arr.push(obj['HRA']);
        //   // arr.push(obj['WA']);
        //   var miscpay = obj['miscpay'];
        //   var str1 = "";
        //   for (var k = 0; k < miscpay.length; k++) {
        //     if (k == 0) {
        //       str1 += miscpay[k]['code'] + " - " + miscpay[k]['amount'];
        //     } else {
        //       str1 += "\n" + miscpay[k]['code'] + " - " + miscpay[k]['amount'];
        //     }

        //   }
        //   if (str1 != "") {
        //     arr.push(str1);
        //   }
        //   else {
        //     arr.push(0.00);
        //   }
        //   arr.push(obj['total']);
        //   var licstr = obj['LIC1'] + "\n" + obj['LIC2'] + "\n" + obj['LIC3'] + "\n" + obj['LIC4'] + "\n" + obj['LIC5'] + "\n" + obj['LIC6'] + "\n" + obj['LIC7'];

        //   arr.push(licstr);
        //   if (obj['PF_arr'] != undefined) {
        //     for (let i = 0; i < obj['PF_arr'].length; i++) {
        //       if (i == 0) {
        //         var PF = obj['PF_arr'][i]

        //       } else {
        //         PF = PF + "\n" + obj['PF_arr'][i]

        //       }


        //     }
        //     arr.push(PF);
        //   } else {
        //     arr.push(obj['PF']);

        //   }
        //   if (obj['NPS_arr'] != undefined) {
        //     for (let i = 0; i < obj['NPS_arr'].length; i++) {
        //       if (i == 0) {
        //         var NPS = obj['NPS_arr'][i]

        //       } else {
        //         NPS = NPS + "\n" + obj['NPS_arr'][i]

        //       }


        //     }
        //     arr.push(NPS);
        //   } else {
        //     arr.push(obj['NPS']);

        //   }
        //   if (obj['GIS_arr'] != undefined) {
        //     for (let i = 0; i < obj['GIS_arr'].length; i++) {
        //       if (i == 0) {
        //         var GIS = obj['GIS_arr'][i]

        //       } else {
        //         GIS = GIS + "\n" + obj['GIS_arr'][i]

        //       }


        //     }
        //     arr.push(GIS);
        //   } else {
        //     arr.push(obj['GIS']);

        //   }
        //   if (obj['IT_arr'] != undefined) {
        //     for (let i = 0; i < obj['IT_arr'].length; i++) {
        //       if (i == 0) {
        //         var IT = obj['IT_arr'][i]

        //       } else {
        //         IT = IT + "\n" + obj['IT_arr'][i]

        //       }


        //     }
        //     arr.push(IT);
        //   } else {
        //     arr.push(obj['IT']);

        //   }
        //   if (obj['HRR_arr'] != undefined) {
        //     for (let i = 0; i < obj['HRR_arr'].length; i++) {
        //       if (i == 0) {
        //         var HRR = obj['HRR_arr'][i]

        //       } else {
        //         HRR = HRR + "\n" + obj['HRR_arr'][i]

        //       }


        //     }
        //     arr.push(HRR);
        //   } else {
        //     arr.push(obj['HRR']);

        //   } if (obj['VD_arr'] != undefined) {
        //     for (let i = 0; i < obj['VD_arr'].length; i++) {
        //       if (i == 0) {
        //         var VD = obj['VD_arr'][i]

        //       } else {
        //         VD = VD + "\n" + obj['VD_arr'][i]

        //       }


        //     }
        //     arr.push(VD);
        //   } else {
        //     arr.push(obj['VD']);

        //   }
        //   if (obj['VADV_arr'] != undefined) {
        //     for (let i = 0; i < obj['VADV_arr'].length; i++) {
        //       if (i == 0) {
        //         var VADV = obj['VADV_arr'][i]

        //       } else {
        //         VADV = VADV + "\n" + obj['VADV_arr'][i]

        //       }


        //     }
        //     arr.push(VADV);
        //   } else {
        //     arr.push(obj['VADV']);

        //   }
        //   /*  arr.push(obj['PF']);
        //    arr.push(obj['NPS']);
        //    arr.push(obj['GIS']);
        //    arr.push(obj['IT']);
        //    arr.push(obj['HRR']);
        //    arr.push(obj['VD']);
        //    arr.push(obj['VADV']); */
        //   var bldstr = obj['BLDADV1'] + "\n" + obj['BLDADV2'] + "\n" + obj['BLDADV3']
        //   arr.push(bldstr);
        //   var pfstr = obj['PFADV'] + "\n" + obj['PFADV1'] + "\n" + obj['PFADV2']
        //   arr.push(pfstr);
        //   arr.push(obj['BADV']);
        //   arr.push(obj['EWF']);
        //   var miscded = obj['miscded'];
        //   var str2 = "";
        //   for (var k = 0; k < miscded.length; k++) {
        //     if (k == 0) {
        //       str2 += miscded[k]['code'] + " - " + miscded[k]['amount'];
        //     } else {
        //       str2 += "\n" + miscded[k]['code'] + " - " + miscded[k]['amount'];
        //     }

        //   }
        //   if (str2 != "") {
        //     arr.push({ text: str2, fontSize: 8 });
        //   }
        //   else {
        //     arr.push(0.00);
        //   }

        // arr.push(obj['net']);

        // dd.content[dd.content.length - 1].table.body.push(arr);
      }

      const filteredData: { [key: string]: number } = {};

      for (const key in total_obj) {
        if (total_obj[key] !== 0) {
          filteredData[key] = total_obj[key];
        }
        else {
          this.arr2.push(key)
        }
      }
      const filteredList:any = list.filter((x, colIndex) => !this.arr2.includes(x));

      for (let i = 0; i < filteredList.length; i++) {
        tbl.table.body[0].push(filteredList[i]);
        tbl.table.widths.push('auto')
      }

      dd.content.push(tbl);
      console.log(filteredData)
      data_keys = this.findMatchingValues(data_keys, filteredData);
      // this.arr1 = this.findMatchingValues1(data_keys, filteredData);
      console.log(data_keys);

      for (var k = 0; k < emps.length; k++) {

        var obj1 = data['data'][emps[k]];
        var arr = [];
        var str = obj1['emp_id'] + "\n" + obj1['emp_name']
        // var str = obj['emp_id'] + "\n" + obj['emp_name'] + "\n" + obj['designation_code'] + "\n" + obj['grade_pay_code'] + "\n" + obj['pay_band'] + "\n" + "SAL A/C - " + obj['sal_acc'];
        // if (obj['pf'] != undefined && obj['pf'] != null && obj['pf'] != 0) {
        //   str += "\n" + "PF A/C - " + obj['pf']
        // }
        // if (obj['pf_ifsc'] != undefined && obj['pf_ifsc'] != null && obj['pf_ifsc'] != 0) {
        //   str += "\n" + "PF Ifsc - " + obj['pf_ifsc']
        // }
        arr.push(str);
        for (const key in filteredData) {
          // if (total_obj[key] !== 0) {
          if (obj1[key] != undefined && key != 'emp_name') {
            arr.push(Number(obj1[key]).toFixed(0));
          }

          // }
        }
        console.log(arr)
        dd.content[dd.content.length - 1].table.body.push(arr);

      }

      dd.content[dd.content.length - 1].table.body.push(Object.values(filteredData));

      // dd.content[dd.content.length - 1].table.body.push(Object.values(total_obj));

      // var obj = data['total'];
      // var arr = [];
      // var str = "Section : " + sections[i] + "\n";
      // str += "Total Employees : " + emps.length;

      // arr.push(str);
      // arr.push(obj['BASIC']);
      // arr.push(obj['DEP']);
      // arr.push(obj['DA']);
      // arr.push(obj['MA']);
      // arr.push(obj['VA']);
      // arr.push(obj['HRA']);
      // arr.push(obj['WA']);
      // var miscpay = obj['miscpay'];
      // var miscpayObj = {};
      // for (var k = 0; k < miscpay.length; k++) {
      //   if (miscpayObj[miscpay[k]['code']] == undefined) {
      //     miscpayObj[miscpay[k]['code']] = 0;
      //   }
      //   miscpayObj[miscpay[k]['code']] += miscpay[k]['amount'];
      // }
      // var str2 = "";
      // var keys = Object.keys(miscpayObj);
      // for (var k = 0; k < keys.length; k++) {
      //   if (k == 0) {
      //     str2 += keys[k] + " - " + miscpayObj[keys[k]];
      //   } else {
      //     str2 += "\n" + keys[k] + " - " + miscpayObj[keys[k]];;
      //   }

      // }
      // if (str2 != "") {
      //   arr.push({ text: str2, fontSize: 8 });
      // }
      // else {
      //   arr.push(0.00);
      // }
      // arr.push(obj['total']);
      // var licstr = obj['LIC1'] + "\n" + obj['LIC2'] + "\n" + obj['LIC3'] + "\n" + obj['LIC4'] + "\n" + obj['LIC5'] + "\n" + obj['LIC6'] + "\n" + obj['LIC7'];

      // arr.push(licstr);
      // arr.push(obj['PF']);
      // arr.push(obj['NPS']);
      // arr.push(obj['GIS']);
      // arr.push(obj['IT']);
      // arr.push(obj['HRR']);
      // arr.push(obj['VD']);
      // arr.push(obj['VADV']);
      // var bldstr = obj['BLDADV1'] + "\n" + obj['BLDADV2'] + "\n" + obj['BLDADV3']
      // arr.push(bldstr);
      // var pfstr = obj['PFADV'] + "\n" + obj['PFADV1'] + "\n" + obj['PFADV2']
      // arr.push(pfstr);
      // arr.push(obj['BADV']);
      // arr.push(obj['EWF']);
      // var miscded = obj['miscded'];
      // var miscdedObj = {};
      // for (var k = 0; k < miscded.length; k++) {
      //   if (miscdedObj[miscded[k]['code']] == undefined) {
      //     miscdedObj[miscded[k]['code']] = 0;
      //   }
      //   miscdedObj[miscded[k]['code']] += miscded[k]['amount'];
      // }
      // var str2 = "";
      // var keys = Object.keys(miscdedObj);
      // for (var k = 0; k < keys.length; k++) {
      //   if (k == 0) {
      //     str2 += keys[k] + " - " + miscdedObj[keys[k]];
      //   } else {
      //     str2 += "\n" + keys[k] + " - " + miscdedObj[keys[k]];;
      //   }

      // }
      // if (str2 != "") {
      //   arr.push({ text: str2, fontSize: 8 });
      // }
      // else {
      //   arr.push(0.00);
      // }

      // arr.push(obj['net']);

      // dd.content[dd.content.length - 1].table.body.push(arr);

    }
    // var totalText = { text: 'Grand Total' + "\nTotal Employees : " + count, fontSize: 10, bold: true };

    // var obj = grand;
    // var arr = []
    // arr.push(totalText);
    // arr.push(obj['BASIC']);
    // arr.push(obj['DEP']);
    // arr.push(obj['DA']);
    // arr.push(obj['MA']);
    // arr.push(obj['VA']);
    // arr.push(obj['HRA']);
    // arr.push(obj['WA']);
    // var miscpay = obj['miscpay'];
    // var miscpayObj = {};
    // for (var k = 0; k < miscpay.length; k++) {
    //   if (miscpayObj[miscpay[k]['code']] == undefined) {
    //     miscpayObj[miscpay[k]['code']] = 0;
    //   }
    //   miscpayObj[miscpay[k]['code']] += miscpay[k]['amount'];
    // }
    // var str2 = "";
    // var keys = Object.keys(miscpayObj);
    // for (var k = 0; k < keys.length; k++) {
    //   if (k == 0) {
    //     str2 += keys[k] + " - " + miscpayObj[keys[k]];
    //   } else {
    //     str2 += "\n" + keys[k] + " - " + miscpayObj[keys[k]];;
    //   }

    // }
    // if (str2 != "") {
    //   arr.push({ text: str2, fontSize: 8 });
    // }
    // else {
    //   arr.push(0.00);
    // }
    // arr.push({ text: obj['total'], bold: true });
    // var amt = obj['LIC1'] + obj['LIC2'] + obj['LIC3'] + obj['LIC4'] + obj['LIC5'] + obj['LIC6'] + obj['LIC7']
    // //var licstr=obj['LIC1']+"\n"+obj['LIC2']+"\n"+obj['LIC3']+"\n"+obj['LIC4']+"\n"+obj['LIC5']+"\n"+obj['LIC6']+"\n"+obj['LIC7'];
    // //var licstr={ text: 'Section : '+sections[i]+"\nTotal Employees : "+emps.length, fontSize: 8};
    // arr.push(amt);
    // arr.push(obj['PF']);
    // arr.push(obj['NPS']);

    // arr.push(obj['GIS']);
    // arr.push(obj['IT']);
    // arr.push(obj['HRR']);
    // arr.push(obj['VD']);
    // arr.push(obj['VADV']);
    // amt = obj['BLDADV1'] + obj['BLDADV2'] + obj['BLDADV3'];
    // //var bldstr=obj['BLDADV1']+"\n"+obj['BLDADV2']+"\n"+obj['BLDADV3']
    // arr.push(amt);
    // amt = obj['PFADV'] + obj['PFADV1'] + obj['PFADV2'];
    // //var pfstr=obj['PFADV']+"\n"+obj['PFADV1']+"\n"+obj['PFADV2']
    // arr.push(amt);
    // arr.push(obj['BADV']);
    // arr.push(obj['EWF']);
    // var miscded = obj['miscded'];
    // var miscdedObj = {};
    // for (var k = 0; k < miscded.length; k++) {
    //   if (miscdedObj[miscded[k]['code']] == undefined) {
    //     miscdedObj[miscded[k]['code']] = 0;
    //   }
    //   miscdedObj[miscded[k]['code']] += miscded[k]['amount'];
    // }
    // var str2 = "";
    // var keys = Object.keys(miscdedObj);
    // for (var k = 0; k < keys.length; k++) {
    //   if (k == 0) {
    //     str2 += keys[k] + " - " + miscdedObj[keys[k]];
    //   } else {
    //     str2 += "\n" + keys[k] + " - " + miscdedObj[keys[k]];;
    //   }

    // }
    // if (str2 != "") {
    //   arr.push({ text: str2, fontSize: 8 });
    // }
    // else {
    //   arr.push(0.00);
    // }

    // arr.push({ text: obj['net'], bold: true });

    // dd.content[dd.content.length - 1].table.body.push(arr);
    dd.content.push("\n\n");
    var sign1 = {
      columns: [
        {
          width: '*',
          text: 'PREPARED BY:',
          bold: true
        },

        {
          width: '*',
          text: 'CHECKED BY:',
          bold: true
        },
        {
          width: '*',
          text: 'SIGNED BY:',
          bold: true
        }


      ],

    }
    dd.content.push("\n\n\n");
    dd.content.push(sign1);
    dd.content.push("\n\n");
    dd.content.push({ text: "CERTIFIED:", bold: true })
    dd.content.push("\n\n");
    dd.content.push({ text: "1. That I have satisfied myself that all the salaries included in the bills drawn in the month of " + this.monthObj[month] + "/" + fin_year + " [the last preceding month] with the exception of those detailed below of which total has been refunded by deduction from the bill has been distributed to the proper persons and their receipts have been taken in acquittance rolls field in my office with reciept-stamp dully cancelled for every payment in access of Rs. 20 and that all leaves and promotions etc have been in the service book of the official concerned." })
    dd.content.push("\n");
    dd.content.push({ text: "2. That all persons for whom pay has been drawn in this bill have actually been entertained during the month." })
    dd.content.push("\n");

    dd.content.push({ text: "3. That all the persons for whom house-rent allowance has been shown in this bill actually occupied a rented house for which they paid rent as shown in this bill and are entitled to the allowance under the standing instructions." })
    dd.content.push("\n");

    dd.content.push({ text: "4. That all the persons in respect of whom conveyance allowance has been drawn in the bill have satisfied me that they have actually maintained the conveyance in a workable condition and have been using them." })
    dd.content.push("\n");

    dd.content.push({ text: "5. That the bill has been checked with the sanctioned in the scale register." })
    dd.content.push("\n");

    dd.content.push({ text: "Date :                                                    Signature Of Drawing Officer:" })
    dd.content.push("\n");

    dd.content.push({ text: "Pay Rs. ....................................." })




    pdfMake.createPdf(dd).download(file_name);
  }


  print(billObj:any, header:any, month:any, fin_year:any) {
    var file_name = header['bill_desc'];
    console.log(billObj, header)
    //var txt = "VARANASASI DEVELOPMENT AUTHORITY(VDA)   Officers/THIRD/FOURTH Category EMPLOYEES STATEMENT FOR THE MONTH OF June,2020   PIRNT DATE: 2020-10-10"
    var txt = this.mainService.accInfo['account_name'] + "(" + this.mainService.accInfo['account_short_name'] + ")" + "   " + header['bill_desc'] + "   Date: " + header['accrual_date'];
    var dd :any= {
      pageSize: 'A2',
      header: function (currentPage:any, pageCount:any) {
        var obj = { text: txt + "     Page No. - " + currentPage, alignment: 'center', margin: [72, 40] };
        return obj;
      },

      //footer: function(currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount; },

      // by default we use portrait, you can change it to landscape if you wish
      pageOrientation: 'landscape',

      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      pageMargins: [40, 60, 40, 60],
      //pageMargins: [ 40, 20, 20, 20 ],
      content: [

      ]
    };

    var header01 = {
      columns: [
        {
          width: '*',
          text: this.mainService.accInfo['address'],
          bold: true,
          alignment: 'center'
        }
      ],

    }
    dd.content.push({ text: " " });
    dd.content.push(header01)
    dd.content.push({ text: " " });
    var sections = Object.keys(billObj);
    var count = 0;
    for (var i = 0; i < sections.length; i++) {
      var data = billObj[sections[i]];

      var sectionText :any= { text: 'Section : ' + sections[i], fontSize: 8 };
      if (i != 0) {
        sectionText['pageBreak'] = 'before'
      }
      let list = ['Emp\nDetail'];
      let data_keys = [];
      let width = ['auto'];
      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'PAY') {
          list.push(this.all_component[i]['component_code'])
          data_keys.push(this.all_component[i]['component_code'])
          width.push('auto')
        }
      }
      list.push('Total');
      data_keys.push('gross_pay');

      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'DED') {
          list.push(this.all_component[i]['component_code']);
          data_keys.push(this.all_component[i]['component_code'])

          width.push('auto')
        }
      }
      list.push('Total Ded');
      data_keys.push('total');
      width.push('auto');
      list.push('Net.\nSal.');
      width.push('auto');
      data_keys.push('net');


      var tbl:any = {
        fontSize: 10,
        table: {
          headerRows: 1,
          widths: [],
          body: [
            []
          ]
        }
      };
      for (let i = 0; i < list.length; i++) {
        tbl.table.body[0].push(list[i]);
        tbl.table.widths.push('auto')
      }
      dd.content.push(tbl);
      var emps = Object.keys(data['data']);
      count = count + emps.length;

      var total_obj :any= new Object();
      total_obj['emp_info'] = 'Total'
      // let total_arr = [];
      //     total_arr.push('Total')
      for (var j = 0; j < emps.length; j++) {
        var obj = data['data'][emps[j]];
        var arr = [];
        var str = obj['emp_id'] + "\n" + obj['emp_name']
        arr.push(str);
        for (let x = 0; x < data_keys.length; x++) {
          if (total_obj[data_keys[x]] == undefined) {
            total_obj[data_keys[x]] = parseInt((obj[data_keys[x]]).toFixed(0))
          } else {
            total_obj[data_keys[x]] = total_obj[data_keys[x]] + parseInt((obj[data_keys[x]]).toFixed(0))
          }
          //deepankar
          //total_arr.push((obj[data_keys[x]]).toFixed(0))
          //deepankar
          arr.push((obj[data_keys[x]]).toFixed(0))
        }


        dd.content[dd.content.length - 1].table.body.push(arr);
      }
      dd.content[dd.content.length - 1].table.body.push(Object.values(total_obj));

      console.log('my total : ', total_obj);


    }
    dd.content.push("\n\n");
    var sign1 = {
      columns: [
        {
          width: '*',
          text: 'PREPARED BY:',
          bold: true
        },

        {
          width: '*',
          text: 'CHECKED BY:',
          bold: true
        },
        {
          width: '*',
          text: 'SIGNED BY:',
          bold: true
        }


      ],

    }
    dd.content.push("\n\n\n");
    dd.content.push(sign1);
    dd.content.push("\n\n");
    dd.content.push({ text: "CERTIFIED:", bold: true })
    dd.content.push("\n\n");
    dd.content.push({ text: "1. That I have satisfied myself that all the salaries included in the bills drawn in the month of " + this.monthObj[month] + "/" + fin_year + " [the last preceding month] with the exception of those detailed below of which total has been refunded by deduction from the bill has been distributed to the proper persons and their receipts have been taken in acquittance rolls field in my office with reciept-stamp dully cancelled for every payment in access of Rs. 20 and that all leaves and promotions etc have been in the service book of the official concerned." })
    dd.content.push("\n");
    dd.content.push({ text: "2. That all persons for whom pay has been drawn in this bill have actually been entertained during the month." })
    dd.content.push("\n");

    dd.content.push({ text: "3. That all the persons for whom house-rent allowance has been shown in this bill actually occupied a rented house for which they paid rent as shown in this bill and are entitled to the allowance under the standing instructions." })
    dd.content.push("\n");

    dd.content.push({ text: "4. That all the persons in respect of whom conveyance allowance has been drawn in the bill have satisfied me that they have actually maintained the conveyance in a workable condition and have been using them." })
    dd.content.push("\n");

    dd.content.push({ text: "5. That the bill has been checked with the sanctioned in the scale register." })
    dd.content.push("\n");

    dd.content.push({ text: "Date :                                                    Signature Of Drawing Officer:" })
    dd.content.push("\n");

    dd.content.push({ text: "Pay Rs. ....................................." })




    pdfMake.createPdf(dd).download(file_name);
  }


  // exportExcel2(billObj, header, erpUser) {

  //   var sections = Object.keys(billObj);
  //   if (sections.length === 0) {
  //     Swal.fire('INFO', 'No Data Found', 'info');
  //     return;
  //   }

  //   this.spinner.show();

  //   let data_to_print = []
  //   let list = []
  //   var count = 0;
  //   for (var i = 0; i < sections.length; i++) {
  //     var data = billObj[sections[i]];
  //     console.log(data)
  //     // list = ['Emp\nDetail'];
  //     list = ['SI NO'];

  //     list.push('Emp Id')
  //     list.push('Emp Name')
  //     list.push('Month')
  //     list.push('Designation')
  //     list.push('Section Code')
  //     // ['Emp\nName'];
  //     let data_keys = [];
  //     for (let i = 0; i < this.all_component.length; i++) {
  //       if (this.all_component[i]['pay_code'] == 'PAY') {
  //         list.push(this.all_component[i]['component_code'])
  //         data_keys.push(this.all_component[i]['component_code'])
  //       }
  //     }
  //     list.push('Total');
  //     data_keys.push('gross_pay');

  //     for (let i = 0; i < this.all_component.length; i++) {
  //       if (this.all_component[i]['pay_code'] == 'DED') {
  //         list.push(this.all_component[i]['component_code']);
  //         data_keys.push(this.all_component[i]['component_code'])
  //       }
  //     }
  //     list.push('Total Ded');
  //     data_keys.push('total');
  //     list.push('Net.\nSal.');
  //     data_keys.push('net');
  //     var emps = Object.keys(data['data']);
  //     count = count + emps.length;

  //     var total_obj = new Object();
  //     total_obj['si_no'] = 'Total'
  //     total_obj['emp_info'] = ''
  //     total_obj['emp_name'] = ''
  //     total_obj['month'] = ''
  //     total_obj['designation'] = ''
  //     total_obj['Section_code'] = ''

  //     let objsall = {}
  //     let temp = {}

  //     for (var j = 0; j < emps.length; j++) {
  //       var obj = data['data'][emps[j]];
  //       var arr = [];

  //       // var str = obj['emp_id'] + "\n" + obj['emp_name']
  //       var str = obj['emp_id']
  //       var str1 = obj['emp_name']

  //       arr.push(j + 1)
  //       arr.push(str);
  //       arr.push(str1);
  //       arr.push(this.monthObj[obj['month']]);
  //       arr.push(obj['designation_code'])
  //       arr.push(obj['leaf_value'])

  //       for (let x = 0; x < data_keys.length; x++) {

  //         if (total_obj[data_keys[x]] == undefined) {
  //           total_obj[data_keys[x]] = parseInt((obj[data_keys[x]]).toFixed(0))
  //         } else {
  //           total_obj[data_keys[x]] = total_obj[data_keys[x]] + parseInt((obj[data_keys[x]]).toFixed(0))
  //         }
  //         arr.push((obj[data_keys[x]]).toFixed(0))
  //         temp['si_no'] = ''
  //         temp['emp_name'] = ''
  //         temp['month'] = ''
  //         temp['designation'] = ''
  //         temp['Section_code'] = 'TOTAL SUM'
  //         temp['emp_info'] = ''
  //         temp[data_keys[x]] = Number(Math.round(obj[data_keys[x]]).toFixed(0))
  //       }




  //       if (objsall[obj['emp_id']] == undefined) {
  //         objsall[obj['emp_id']] = {}
  //         // +'-'+data_keys[x]]={}
  //         objsall[obj['emp_id']] = Object.assign({}, temp)
  //       } else {
  //         for (let x = 0; x < data_keys.length; x++) {
  //           // objsall[obj['emp_id']][data_keys[x]]=0
  //           objsall[obj['emp_id']][data_keys[x]] = objsall[obj['emp_id']][data_keys[x]] + Number(Math.round((obj[data_keys[x]]).toFixed(0)))


  //         }


  //       }
  //       data_to_print.push(arr)




  //       if (j != emps.length - 1 && emps[j].split('-')[0] == emps[j + 1].split('-')[0]) {


  //       } else {

  //         data_to_print.push(Object.values(objsall[obj['emp_id']]))






  //       }


  //     }
  //     data_to_print.push(Object.values(total_obj))
  //   }

  //   const workbook = new Workbook();
  //   const worksheet = workbook.addWorksheet('arrear_bill');


  //   var title = erpUser['account_name'] + "(" + erpUser['account_short_name'] + ")" + "   " + header['bill_desc'] + "   Date: " + header['accrual_date'];

  //   //Add Row and formatting
  //   let titleRow = worksheet.addRow([title]);
  //   titleRow.alignment = { vertical: 'distributed', horizontal: 'center' };
  //   titleRow.font = { size: 14, bold: true }


  //   worksheet.mergeCells('A1:AL2');
  //   worksheet.getCell('A1').border = { top: { style: 'thick' }, left: { style: 'thick' }, bottom: { style: 'thick' }, right: { style: 'thick' } };

  //   // let header_arr = ['Emp Detail', 'BASIC', 'CCA', 'Comp Alw', 'CONV', 'DA', 'DEP-ALLOW', 'HRA', 'HVDT Allow', 'MED', 'Per Pay',
  //   //   'Res Alw', 'WA', 'Handicapped Allowance', 'PR BHATTA', 'Washing Allowance', 'Total', 'Comp-Loan', 'Cons-Loan', 'CPF/GPF Ded', 'Fest Adv',
  //   //   'GIS', 'H. RENT', 'HB Adv', 'HDFC', 'L Tax', 'Misc Ded', 'NPS', 'Other Adv', 'Other Ded', 'PF', 'PF Advance', 'Veh Loan', 'WF', 'E.P.F',
  //   //   'IT', 'Total Ded', 'Net.Sal'

  //   // ]

  //   const rowIndex = 3;
  //   list.map((x, colIndex) => {
  //     worksheet.getCell(rowIndex, colIndex + 1).value = x;
  //     worksheet.getCell(rowIndex, colIndex + 1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' } }
  //     worksheet.getCell(rowIndex, colIndex + 1).alignment = { vertical: 'distributed', horizontal: 'center' };
  //     worksheet.getCell(rowIndex, colIndex + 1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
  //     worksheet.getCell(rowIndex, colIndex + 1).font = { size: 10, bold: true }
  //   })



  //   //inserting data
  //   data_to_print.forEach((d, i) => {
  //     let row = worksheet.addRow(d);
  //     row.alignment = { vertical: 'distributed', horizontal: 'center' }
  //     if (i === data_to_print.length - 1) {
  //       row.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' } }
  //       row.alignment = { vertical: 'distributed', horizontal: 'center' };
  //       row.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
  //       row.font = { size: 12, bold: true }

  //     }
  //   });

  //   this.spinner.hide();
  //   //  save excel file
  //   workbook.xlsx.writeBuffer().then((data: ArrayBuffer) => {
  //     const blob = new Blob([data]);
  //     fs.saveAs(blob, 'Arrear_Bill.xlsx')
  //   })
  // }
  // arr1 = []

  exportExcel2(billObj:any, header:any, erpUser:any) {

    var sections = Object.keys(billObj);
    if (sections.length === 0) {
      Swal.fire('INFO', 'No Data Found', 'info');
      return;
    }

    this.spinner.show();
    let flag:any = true;
    let data_to_print:any = []
    let list :any= []
    var count:any = 0;
    let data_keys: any = [];
    for (var i = 0; i < sections.length; i++) {
      var data = billObj[sections[i]];
      console.log(data)
      // list = ['Emp\nDetail'];
      list = ['SI NO'];

      list.push('Emp Id')
      list.push('Emp Name')
      list.push('Month')
      list.push('Designation')
      list.push('Section Code')
      // ['Emp\nName'];
      data_keys = [];
      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'PAY') {
          list.push(this.all_component[i]['component_code'])
          data_keys.push(this.all_component[i]['component_code'])
        }
      }
      list.push('Total');
      data_keys.push('gross_pay');

      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'DED') {
          list.push(this.all_component[i]['component_code']);
          data_keys.push(this.all_component[i]['component_code'])
        }
      }
      list.push('Total Ded');
      data_keys.push('total');
      list.push('Net.\nSal.');
      data_keys.push('net');
      var emps = Object.keys(data['data']);
      count = count + emps.length;

      var total_obj :any= new Object();
      total_obj['si_no'] = 'Total'
      total_obj['emp_info'] = ''
      total_obj['emp_name'] = ''
      total_obj['month'] = ''
      total_obj['designation'] = ''
      total_obj['Section_code'] = ''

      let objsall :any= {}
      let temp :any= {}

      for (var j = 0; j < emps.length; j++) {
        var obj = data['data'][emps[j]];
        var arr = [];

        // var str = obj['emp_id'] + "\n" + obj['emp_name']
        var str = obj['emp_id']
        var str1 = obj['emp_name']

        // arr.push(j + 1)
        // arr.push(str);
        // arr.push(str1);
        // arr.push(this.monthObj[obj['month']]);
        // arr.push(obj['designation_code'])
        // arr.push(obj['leaf_value'])

        for (let x = 0; x < data_keys.length; x++) {

          if (total_obj[data_keys[x]] == undefined) {
            total_obj[data_keys[x]] = Number(Math.round(obj[data_keys[x]]).toFixed(0))
          } else {
            total_obj[data_keys[x]] = total_obj[data_keys[x]] + Number(Math.round(obj[data_keys[x]]).toFixed(0))
          }
          // arr.push((obj[data_keys[x]]).toFixed(0))

          // temp[data_keys[x]] = Number(Math.round(obj[data_keys[x]]).toFixed(0))
        }




        if (j != emps.length - 1 && emps[j].split('-')[0] == emps[j + 1].split('-')[0]) {


        } else {

          // data_to_print.push(Object.values(objsall[obj['emp_id']]))






        }


      }
      // data_to_print.push(Object.values(total_obj))

      const filteredData: { [key: string]: number } = {};

      for (const key in total_obj) {
        if (total_obj[key] !== 0) {
          filteredData[key] = total_obj[key];
        }
        else {
          this.arr1.push(key)
        }
      }
      console.log(filteredData)
      data_keys = this.findMatchingValues(data_keys, filteredData);
      // this.arr1 = this.findMatchingValues1(data_keys, filteredData);
      console.log(data_keys);
      console.log(this.arr1);


      for (var j = 0; j < emps.length; j++) {
        var obj = data['data'][emps[j]];
        var arr = [];
        // if (flag) {
        //   // arr.push(count)

        //   var str = obj['emp_id']
        //   var str1 = obj['emp_name']

        // arr.push(j + 1)
        // arr.push(str);
        // arr.push(str1);
        // arr.push(this.monthObj[obj['month']]);
        // arr.push(obj['designation_code'])
        // arr.push(obj['leaf_value'])

        //   flag = false;
        // } else {
        //   arr.push('')
        //   arr.push('')
        //   arr.push('')
        //   arr.push('')
        //   arr.push('')
        //   arr.push('')
        // }
        var str = obj['emp_id']
        var str1 = obj['emp_name']

        arr.push(j + 1)
        arr.push(str);
        arr.push(str1);
        arr.push(this.monthObj[obj['month']]);
        arr.push(obj['designation_code'])
        arr.push(obj['leaf_value'])

        for (const key in filteredData) {


          if (typeof obj[key] == 'number') {
            arr.push(Number(Math.round(obj[key]).toFixed(0)))
          }

          if (key == 'si_no' || key == 'emp_name' || key == 'month' || key == 'designation' || key == 'Section_code') {
            temp['si_no'] = ''
            temp['emp_name'] = ''
            temp['month'] = ''
            temp['designation'] = ''
            temp['Section_code'] = 'TOTAL SUM'
            temp['emp_info'] = ''
          }
          else {
            temp[key] = Number(Math.round(obj[key]).toFixed(0))
          }
          // temp['emp_info'] = ''
          // if(temp[key]!=undefined){

          //   }
          //  else{
          //   temp[key]=''
          //  }
        }




        if (objsall[obj['emp_id']] == undefined) {
          objsall[obj['emp_id']] = {}
          // +'-'+data_keys[x]]={}
          objsall[obj['emp_id']] = Object.assign({}, temp)
        } else {
          for (const key in filteredData) {
            if (key == 'si_no' || key == 'emp_name' || key == 'month' || key == 'designation' || key == 'Section_code' || key == 'emp_info') {
              temp['si_no'] = ''
              temp['emp_name'] = ''
              temp['month'] = ''
              temp['designation'] = ''
              temp['Section_code'] = 'TOTAL SUM'
              temp['emp_info'] = ''
            } else {
              // objsall[obj['emp_id']][key]=0
              objsall[obj['emp_id']][key] = objsall[obj['emp_id']][key] + Number(Math.round(obj[key]).toFixed(0))

            }


          }


        }
        data_to_print.push(arr)




        if (j != emps.length - 1 && emps[j].split('-')[0] == emps[j + 1].split('-')[0]) {


        } else {

          data_to_print.push(Object.values(objsall[obj['emp_id']]))






        }


      }
      data_to_print.push(Object.values(filteredData))

    }



    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('arrear_bill');


    var title = erpUser['account_name'] + "(" + erpUser['account_short_name'] + ")" + "   " + header['bill_desc'] + "   Date: " + header['accrual_date'];

    //Add Row and formatting
    let titleRow = worksheet.addRow([title]);
    titleRow.alignment = { vertical: 'distributed', horizontal: 'center' };
    titleRow.font = { size: 14, bold: true }


    worksheet.mergeCells('A1:M2');
    worksheet.getCell('A1').border = { top: { style: 'thick' }, left: { style: 'thick' }, bottom: { style: 'thick' }, right: { style: 'thick' } };

    const filteredList = list.filter((x:any, colIndex:any) => !this.arr1.includes(x));

    const rowIndex = 3;
    filteredList.map((x:any, colIndex:any) => {
      if (!(this.arr1.includes(x))) {
        worksheet.getCell(rowIndex, colIndex + 1).value = x;
        worksheet.getCell(rowIndex, colIndex + 1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' } }
        worksheet.getCell(rowIndex, colIndex + 1).alignment = { vertical: 'distributed', horizontal: 'center' };
        worksheet.getCell(rowIndex, colIndex + 1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        worksheet.getCell(rowIndex, colIndex + 1).font = { size: 10, bold: true }
      }

    })



    //inserting data
    data_to_print.forEach((d:any, i:any) => {
      let row = worksheet.addRow(d);
      row.alignment = { vertical: 'distributed', horizontal: 'center' }
      if (i === data_to_print.length - 1) {
        row.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' } }
        row.alignment = { vertical: 'distributed', horizontal: 'center' };
        row.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        row.font = { size: 12, bold: true }

      }
    });

    this.spinner.hide();
    //  save excel file
    workbook.xlsx.writeBuffer().then((data: ArrayBuffer) => {
      const blob = new Blob([data]);
      fs.saveAs(blob, 'Arrear_Bill.xlsx')
    })
  }
  arr1 :any= []
  exportExcel1(billObj:any, header:any, erpUser:any) {
    this.arr1 = []
    console.log(billObj)
    var sections = Object.keys(billObj);
    if (sections.length === 0) {
      Swal.fire('INFO', 'No Data Found', 'info');
      return;
    }

    this.spinner.show();

    let data_to_print = []
    let list: any = []
    var count = 0;
    for (var i = 0; i < sections.length; i++) {
      var data = billObj[sections[i]];
      console.log(data)
      // list = ['Emp\nDetail'];
      list = ['SI NO'];
      list.push('Emp Id')
      list.push('Emp Name')
      list.push('Designation')
      list.push('Section Code')
      // ['Emp\nName'];
      let data_keys: any = [];
      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'PAY') {
          list.push(this.all_component[i]['component_code'])
          data_keys.push(this.all_component[i]['component_code'])
        }
      }
      list.push('Total');
      data_keys.push('gross_pay');

      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'DED') {
          list.push(this.all_component[i]['component_code']);
          data_keys.push(this.all_component[i]['component_code'])
        }
      }
      list.push('Total Ded');
      data_keys.push('total');
      list.push('Net.\nSal.');
      data_keys.push('net');
      var emps = Object.keys(data['data']);
      count = count + emps.length;

      var total_obj :any= new Object();
      total_obj['si_no'] = 'Total'
      total_obj['emp_info'] = ''
      total_obj['emp_name'] = ''
      total_obj['designation'] = ''
      total_obj['Section_code'] = ''
      for (var j = 0; j < emps.length; j++) {
        var obj = data['data'][emps[j]];
        // var arr = [];
        // // var str = obj['emp_id'] + "\n" + obj['emp_name']
        // var str = obj['emp_id']
        // var str1 = obj['emp_name']

        // arr.push(j + 1)
        // arr.push(str);
        // arr.push(str1);
        // arr.push(obj['designation_code'])
        // arr.push(obj['leaf_value'])
        for (let x = 0; x < data_keys.length; x++) {
          if (total_obj[data_keys[x]] == undefined) {
            total_obj[data_keys[x]] = parseInt((obj[data_keys[x]]).toFixed(0))
          } else {
            total_obj[data_keys[x]] = total_obj[data_keys[x]] + parseInt((obj[data_keys[x]]).toFixed(0))
          }

          // arr.push((obj[data_keys[x]]).toFixed(0))
        }

        // data_to_print.push(arr)
      }

      const filteredData: { [key: string]: number } = {};

      for (const key in total_obj) {
        if (total_obj[key] !== 0) {
          filteredData[key] = total_obj[key];
        }
        else {
          this.arr1.push(key)
        }
      }
      console.log(filteredData)
      data_keys = this.findMatchingValues(data_keys, filteredData);
      // this.arr1 = this.findMatchingValues1(data_keys, filteredData);
      console.log(data_keys);
      console.log(this.arr1);
      for (var k = 0; k < emps.length; k++) {

        var obj1 = data['data'][emps[k]];
        var arr = [];
        // var str = obj['emp_id'] + "\n" + obj['emp_name']
        var str = obj1['emp_id']
        var str1 = obj1['emp_name']

        arr.push(k + 1)
        arr.push(str);
        arr.push(str1);
        arr.push(obj1['designation_code'])
        arr.push(obj1['leaf_value'])
        for (const key in filteredData) {
          // if (total_obj[key] !== 0) {
          if (obj1[key] != undefined && key != 'emp_name') {
            arr.push(Number(obj1[key]).toFixed(0));
          }

          // }
        }
        data_to_print.push(arr)

      }
      data_to_print.push(Object.values(filteredData))




      // data_to_print.push(Object.values(total_obj))



    }

    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('salary_bill');

    if (data['district'] != undefined) {
      var title = erpUser['account_name'] + "(" + erpUser['account_short_name'] + ")" + erpUser['address'] + "   " + header['bill_desc'] + "(" + data['district'] + " )   Date: " + header['accrual_date'];

    }
    else {
      var title = erpUser['account_name'] + "(" + erpUser['account_short_name'] + ")"

      var title1 = erpUser['address']

      var title2:any = header['bill_desc'] + "   Date: " + header['accrual_date'];

    }
    // Add Row and formatting for titleRow
    let titleRow = worksheet.addRow([title]);
    titleRow.alignment = { vertical: 'distributed', horizontal: 'center' };
    titleRow.font = { size: 14, bold: true }

    // Add Row and formatting for titleRow1
    let titleRow1 = worksheet.addRow([title1]);
    titleRow1.alignment = { vertical: 'distributed', horizontal: 'center' };
    titleRow1.font = { size: 14, bold: true }

    // Add Row and formatting for titleRow2
    let titleRow2 = worksheet.addRow([title2]);
    titleRow2.alignment = { vertical: 'distributed', horizontal: 'center' };
    titleRow2.font = { size: 14, bold: true }

    // Merge cells for titleRow
    worksheet.mergeCells('A1:T1');

    // Merge cells for titleRow1
    worksheet.mergeCells('A2:T2');

    // Merge cells for titleRow2
    worksheet.mergeCells('A3:T3');

    // Set border for the merged cells
    worksheet.getCell('A1').border = { top: { style: 'thick' }, left: { style: 'thick' }, bottom: { style: 'thick' }, right: { style: 'thick' } };
    worksheet.getCell('A2').border = { top: { style: 'thick' }, left: { style: 'thick' }, bottom: { style: 'thick' }, right: { style: 'thick' } };
    worksheet.getCell('A3').border = { top: { style: 'thick' }, left: { style: 'thick' }, bottom: { style: 'thick' }, right: { style: 'thick' } };


    // //Add Row and formatting
    // let titleRow = worksheet.addRow([title]);
    // titleRow.alignment = { vertical: 'distributed', horizontal: 'center' };
    // titleRow.font = { size: 14, bold: true }


    // worksheet.mergeCells('A2:T1');
    // worksheet.getCell('A1').border = { top: { style: 'thick' }, left: { style: 'thick' }, bottom: { style: 'thick' }, right: { style: 'thick' } };

    // let header_arr = ['Emp Detail', 'BASIC', 'CCA', 'Comp Alw', 'CONV', 'DA', 'DEP-ALLOW', 'HRA', 'HVDT Allow', 'MED', 'Per Pay',
    //   'Res Alw', 'WA', 'Handicapped Allowance', 'PR BHATTA', 'Washing Allowance', 'Total', 'Comp-Loan', 'Cons-Loan', 'CPF/GPF Ded', 'Fest Adv',
    //   'GIS', 'H. RENT', 'HB Adv', 'HDFC', 'L Tax', 'Misc Ded', 'NPS', 'Other Adv', 'Other Ded', 'PF', 'PF Advance', 'Veh Loan', 'WF', 'E.P.F',
    //   'IT', 'Total Ded', 'Net.Sal'

    // ]
    const filteredList = list.filter((x:any, colIndex:any) => !this.arr1.includes(x));

    const rowIndex = 4;
    filteredList.map((x:any, colIndex:any) => {
      if (!(this.arr1.includes(x))) {

        worksheet.getCell(rowIndex, colIndex + 1).value = x;
        worksheet.getCell(rowIndex, colIndex + 1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' } }
        worksheet.getCell(rowIndex, colIndex + 1).alignment = { vertical: 'distributed', horizontal: 'center' };
        worksheet.getCell(rowIndex, colIndex + 1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        worksheet.getCell(rowIndex, colIndex + 1).font = { size: 10, bold: true }
      }

    })


    data_to_print.push([]);
    data_to_print.push(['PREPARED BY:'])
    data_to_print.push(['CHECKED BY:'])
    data_to_print.push(['SIGNED BY:'])

    data_to_print.push([]);

    //inserting data
    data_to_print.forEach((d:any, i:any) => {
      let row = worksheet.addRow(d);
      row.alignment = { vertical: 'distributed', horizontal: 'center' }

      if(d=='SIGNED BY:' || d=='CHECKED BY:' || d=='PREPARED BY:'){
        // row.border =  { top: { style: 'thick' }, left: { style: 'thick' }, bottom: { style: 'thick' }, right: { style: 'thick' } };
        row.font = { size: 14, bold: true }
      }
      // if (i === data_to_print.length - 1) {
      //   row.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' } }
      //   row.alignment = { vertical: 'distributed', horizontal: 'center' };
      //   row.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      //   row.font = { size: 12, bold: true }


      // }

    });

    this.spinner.hide();
    //  save excel file
    workbook.xlsx.writeBuffer().then((data: ArrayBuffer) => {
      const blob = new Blob([data]);
      fs.saveAs(blob, 'Salary_Bill.xlsx')
    })
  }

  findMatchingValues(array:any, object:any) {
    const matchingValues:any = {};

    array.forEach((key:any) => {
      if (object.hasOwnProperty(key)) {
        matchingValues[key] = object[key];
      }

    });

    return matchingValues;
  }


  findMatchingValues1(array:any, object:any) {
    const matchingValues :any= [];

    array.forEach((key:any) => {
      if (object.hasOwnProperty(key)) {
        // matchingValues[key] = object[key];
      }
      else {
        matchingValues[key] = object[key];

      }
    });

    return matchingValues;
  }

  // exportExcel1(billObj, header, erpUser) {

  //   var sections = Object.keys(billObj);
  //   if (sections.length === 0) {
  //     Swal.fire('INFO', 'No Data Found', 'info');
  //     return;
  //   }

  //   this.spinner.show();

  //   let data_to_print = []
  //   let list = []
  //   var count = 0;
  //   for (var i = 0; i < sections.length; i++) {
  //     var data = billObj[sections[i]];
  //     console.log(data)
  //     // list = ['Emp\nDetail'];
  //     list = ['SI NO'];
  //     list.push('Emp Id')
  //     list.push('Emp Name')
  //     list.push('Designation')
  //     list.push('Section Code')
  //     // ['Emp\nName'];
  //     let data_keys = [];
  //     for (let i = 0; i < this.all_component.length; i++) {
  //       if (this.all_component[i]['pay_code'] == 'PAY') {
  //         list.push(this.all_component[i]['component_code'])
  //         data_keys.push(this.all_component[i]['component_code'])
  //       }
  //     }
  //     list.push('Total');
  //     data_keys.push('gross_pay');

  //     for (let i = 0; i < this.all_component.length; i++) {
  //       if (this.all_component[i]['pay_code'] == 'DED') {
  //         list.push(this.all_component[i]['component_code']);
  //         data_keys.push(this.all_component[i]['component_code'])
  //       }
  //     }
  //     list.push('Total Ded');
  //     data_keys.push('total');
  //     list.push('Net.\nSal.');
  //     data_keys.push('net');
  //     var emps = Object.keys(data['data']);
  //     count = count + emps.length;

  //     var total_obj = new Object();
  //     total_obj['si_no'] = 'Total'
  //     total_obj['emp_info'] = ''
  //     total_obj['emp_name'] = ''
  //     total_obj['designation'] = ''
  //     total_obj['Section_code'] = ''
  //     for (var j = 0; j < emps.length; j++) {
  //       var obj = data['data'][emps[j]];
  //       var arr = [];
  //       // var str = obj['emp_id'] + "\n" + obj['emp_name']
  //       var str = obj['emp_id']
  //       var str1 = obj['emp_name']

  //       arr.push(j + 1)
  //       arr.push(str);
  //       arr.push(str1);
  //       arr.push(obj['designation_code'])
  //       arr.push(obj['leaf_value'])
  //       for (let x = 0; x < data_keys.length; x++) {
  //         if (total_obj[data_keys[x]] == undefined) {
  //           total_obj[data_keys[x]] = parseInt((obj[data_keys[x]]).toFixed(0))
  //         } else {
  //           total_obj[data_keys[x]] = total_obj[data_keys[x]] + parseInt((obj[data_keys[x]]).toFixed(0))
  //         }

  //         arr.push((obj[data_keys[x]]).toFixed(0))
  //       }

  //       data_to_print.push(arr)
  //     }
  //   //   const filteredData: { [key: string]: number } = {};

  //   //   for (const key in total_obj) {
  //   //     if (total_obj[key] !== 0) {
  //   //       filteredData[key] = total_obj[key];
  //   //     }
  //   //   }
  //   //  console.log(filteredData)
  //   //   data_to_print.push(Object.values(filteredData))
  //     data_to_print.push(Object.values(total_obj))
  //   }

  //   const workbook = new Workbook();
  //   const worksheet = workbook.addWorksheet('salary_bill');


  //   var title = erpUser['account_name'] + "(" + erpUser['account_short_name'] + ")" + "   " + header['bill_desc'] + "   Date: " + header['accrual_date'];

  //   //Add Row and formatting
  //   let titleRow = worksheet.addRow([title]);
  //   titleRow.alignment = { vertical: 'distributed', horizontal: 'center' };
  //   titleRow.font = { size: 14, bold: true }


  //   worksheet.mergeCells('A1:AL2');
  //   worksheet.getCell('A1').border = { top: { style: 'thick' }, left: { style: 'thick' }, bottom: { style: 'thick' }, right: { style: 'thick' } };

  //   // let header_arr = ['Emp Detail', 'BASIC', 'CCA', 'Comp Alw', 'CONV', 'DA', 'DEP-ALLOW', 'HRA', 'HVDT Allow', 'MED', 'Per Pay',
  //   //   'Res Alw', 'WA', 'Handicapped Allowance', 'PR BHATTA', 'Washing Allowance', 'Total', 'Comp-Loan', 'Cons-Loan', 'CPF/GPF Ded', 'Fest Adv',
  //   //   'GIS', 'H. RENT', 'HB Adv', 'HDFC', 'L Tax', 'Misc Ded', 'NPS', 'Other Adv', 'Other Ded', 'PF', 'PF Advance', 'Veh Loan', 'WF', 'E.P.F',
  //   //   'IT', 'Total Ded', 'Net.Sal'

  //   // ]

  //   const rowIndex = 3;
  //   list.map((x, colIndex) => {
  //     worksheet.getCell(rowIndex, colIndex + 1).value = x;
  //     worksheet.getCell(rowIndex, colIndex + 1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' } }
  //     worksheet.getCell(rowIndex, colIndex + 1).alignment = { vertical: 'distributed', horizontal: 'center' };
  //     worksheet.getCell(rowIndex, colIndex + 1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
  //     worksheet.getCell(rowIndex, colIndex + 1).font = { size: 10, bold: true }
  //   })



  //   //inserting data
  //   data_to_print.forEach((d, i) => {
  //     let row = worksheet.addRow(d);
  //     row.alignment = { vertical: 'distributed', horizontal: 'center' }
  //     if (i === data_to_print.length - 1) {
  //       row.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' } }
  //       row.alignment = { vertical: 'distributed', horizontal: 'center' };
  //       row.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
  //       row.font = { size: 12, bold: true }

  //     }
  //   });

  //   this.spinner.hide();
  //   //  save excel file
  //   workbook.xlsx.writeBuffer().then((data: ArrayBuffer) => {
  //     const blob = new Blob([data]);
  //     fs.saveAs(blob, 'Salary_Bill.xlsx')
  //   })
  // }

  exportExcel(billObj:any, header:any, erpUser:any) {

    var sections = Object.keys(billObj);
    if (sections.length === 0) {
      Swal.fire('INFO', 'No Data Found', 'info');
      return;
    }

    this.spinner.show();

    let data_to_print = []
    let list:any = []
    var count :any= 0;
    for (var i = 0; i < sections.length; i++) {
      var data = billObj[sections[i]];

      // list = ['Emp\nDetail'];
      list = ['SI NO'];
      list.push('Emp Id')
      list.push('Emp Name')
      // list.push('Designation')
      // list.push('Section Code')
      // ['Emp\nName'];
      let data_keys = [];
      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'PAY') {
          list.push(this.all_component[i]['component_code'])
          data_keys.push(this.all_component[i]['component_code'])
        }
      }
      list.push('Total');
      data_keys.push('gross_pay');

      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'DED') {
          list.push(this.all_component[i]['component_code']);
          data_keys.push(this.all_component[i]['component_code'])
        }
      }
      list.push('Total Ded');
      data_keys.push('total');
      list.push('Net.\nSal.');
      data_keys.push('net');
      var emps = Object.keys(data['data']);
      count = count + emps.length;

      var total_obj:any = new Object();

      total_obj['si_no'] = 'Total'
      total_obj['emp_info'] = ''
      total_obj['emp_name'] = ''
      // total_obj['designation']=''
      // total_obj['Section_code']=''
      for (var j = 0; j < emps.length; j++) {
        var obj = data['data'][emps[j]];
        var arr = [];
        // var str = obj['emp_id'] + "\n" + obj['emp_name']
        var str = obj['emp_id']
        var str1 = obj['emp_name']

        arr.push(j + 1)
        arr.push(str);
        arr.push(str1);
        // arr.push(obj['designation_code'])
        // arr.push(obj['leaf_value'])
        for (let x = 0; x < data_keys.length; x++) {
          if (total_obj[data_keys[x]] == undefined) {
            total_obj[data_keys[x]] = parseInt((obj[data_keys[x]]).toFixed(0))
          } else {
            total_obj[data_keys[x]] = total_obj[data_keys[x]] + parseInt((obj[data_keys[x]]).toFixed(0))
          }

          arr.push((obj[data_keys[x]]).toFixed(0))
        }

        data_to_print.push(arr)
      }
      data_to_print.push(Object.values(total_obj))
    }

    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('salary_bill');


    var title = erpUser['account_name'] + "(" + erpUser['account_short_name'] + ")" + "   " + header['bill_desc'] + "   Date: " + header['accrual_date'];

    //Add Row and formatting
    let titleRow = worksheet.addRow([title]);
    titleRow.alignment = { vertical: 'distributed', horizontal: 'center' };
    titleRow.font = { size: 14, bold: true }


    worksheet.mergeCells('A1:AL2');
    worksheet.getCell('A1').border = { top: { style: 'thick' }, left: { style: 'thick' }, bottom: { style: 'thick' }, right: { style: 'thick' } };

    // let header_arr = ['Emp Detail', 'BASIC', 'CCA', 'Comp Alw', 'CONV', 'DA', 'DEP-ALLOW', 'HRA', 'HVDT Allow', 'MED', 'Per Pay',
    //   'Res Alw', 'WA', 'Handicapped Allowance', 'PR BHATTA', 'Washing Allowance', 'Total', 'Comp-Loan', 'Cons-Loan', 'CPF/GPF Ded', 'Fest Adv',
    //   'GIS', 'H. RENT', 'HB Adv', 'HDFC', 'L Tax', 'Misc Ded', 'NPS', 'Other Adv', 'Other Ded', 'PF', 'PF Advance', 'Veh Loan', 'WF', 'E.P.F',
    //   'IT', 'Total Ded', 'Net.Sal'

    // ]

    const rowIndex = 3;
    list.map((x:any, colIndex:any) => {
      worksheet.getCell(rowIndex, colIndex + 1).value = x;
      worksheet.getCell(rowIndex, colIndex + 1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' } }
      worksheet.getCell(rowIndex, colIndex + 1).alignment = { vertical: 'distributed', horizontal: 'center' };
      worksheet.getCell(rowIndex, colIndex + 1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      worksheet.getCell(rowIndex, colIndex + 1).font = { size: 10, bold: true }
    })



    //inserting data
    data_to_print.forEach((d, i) => {
      let row = worksheet.addRow(d);
      row.alignment = { vertical: 'distributed', horizontal: 'center' }
      if (i === data_to_print.length - 1) {
        row.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' } }
        row.alignment = { vertical: 'distributed', horizontal: 'center' };
        row.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        row.font = { size: 12, bold: true }

      }
    });

    this.spinner.hide();
    //  save excel file
    workbook.xlsx.writeBuffer().then((data: ArrayBuffer) => {
      const blob = new Blob([data]);
      fs.saveAs(blob, 'Salary_Bill.xlsx')
    })
  }



}
